import type { CustomsConfig } from '../../../domain/types/configs/company/CustomsConfig';

export const customsConfig: CustomsConfig = {
  warehouses: [
    {
      isActive: false,
      warehouseCode: "G2",
      warehouseName: "ADUANA EXPRESS AEREO (COMBEX)"
    },
    {
      isActive: false,
      warehouseCode: "G4",
      warehouseName: "ADUANA EXPRESS AÉREO COMBEX IM"
    },
    {
      warehouseCode: "02",
      isActive: false,
      warehouseName: "AERIS"
    },
    {
      warehouseCode: "G1",
      isActive: false,
      warehouseName: "ALMACENADORA DEL PAIZ"
    },
    {
      isActive: false,
      warehouseName: "BCF",
      warehouseCode: "08"
    },
    {
      isActive: false,
      warehouseName: "BODEGA EXTRANJERO",
      warehouseCode: "28"
    },
    {
      warehouseName: "BODEGA PROMED-GUATEMALA",
      isActive: false,
      warehouseCode: "G3"
    },
    {
      isActive: false,
      warehouseName: "CAPSI LAS GARZAS",
      warehouseCode: "49"
    },
    {
      isActive: false,
      warehouseName: "CHM CAJA DE SEGURO SOCIAL",
      warehouseCode: "32"
    },
    {
      isActive: false,
      warehouseCode: "19",
      warehouseName: "CLIENTE"
    },
    {
      warehouseCode: "34",
      isActive: false,
      warehouseName: "CSS / HOSPITAL EL VIGIA (NVO.)"
    },
    {
      warehouseName: "FRANCE FIELD",
      warehouseCode: "45",
      isActive: false
    },
    {
      isActive: false,
      warehouseCode: "39",
      warehouseName: "HOSPITAL DEL ESTE"
    },
    {
      isActive: false,
      warehouseCode: "18",
      warehouseName: "HUZA CAPITAL"
    },
    {
      warehouseName: "INSTITUTO ONCOLÓGICO NACIONAL",
      warehouseCode: "52",
      isActive: false
    },
    {
      warehouseCode: "43",
      isActive: false,
      warehouseName: "INTERTRADE"
    },
    {
      isActive: false,
      warehouseCode: "20",
      warehouseName: "LABORATORIO GORGAS"
    },
    {
      warehouseName: "MEDIPAN (COLÒN)",
      isActive: false,
      warehouseCode: "27"
    },
    {
      warehouseName: "MINSA / HOSPITAL DEL ESTE",
      warehouseCode: "40",
      isActive: false
    },
    {
      isActive: false,
      warehouseCode: "41",
      warehouseName: "N/O"
    },
    {
      warehouseCode: "36",
      warehouseName: "PTY CARGO EXPRESS",
      isActive: false
    },
    {
      warehouseCode: "29",
      isActive: false,
      warehouseName: "QUALITY FREIGHT CORP. (CE)"
    },
    {
      isActive: false,
      warehouseName: "SCHERING PLOUGH (ZLC)",
      warehouseCode: "30"
    },
    {
      warehouseName: "SERTRANS (AEROPUERTO)",
      warehouseCode: "13",
      isActive: false
    },
    {
      isActive: false,
      warehouseName: "SUPREME (AEROPUERTO)",
      warehouseCode: "14"
    },
    {
      warehouseName: "TERMINALES UNIDAS",
      isActive: false,
      warehouseCode: "05"
    },
    {
      warehouseName: "TRANSPANA (PANAMÁ - PACÍFICO)",
      isActive: false,
      warehouseCode: "53"
    },
    {
      warehouseName: "AEROPUERTO DE PASAJERO",
      isActive: true,
      warehouseCode: "47"
    },
    {
      warehouseName: "AEROPUERTO JUAN SANTAMARIA",
      warehouseCode: "06",
      isActive: true
    },
    {
      warehouseName: "ALMACENADORA KINTE",
      warehouseCode: "55",
      isActive: true
    },
    {
      warehouseCode: "1",
      warehouseName: "ALMACENADORA MERCANTIL",
      isActive: true
    },
    {
      warehouseName: "BCR",
      isActive: true,
      warehouseCode: "07"
    },
    {
      isActive: true,
      warehouseCode: "60",
      warehouseName: "BODEGA EL SALVADOR"
    },
    {
      warehouseName: "BODEGA PROMED-GUATEMALA",
      isActive: true,
      warehouseCode: "03"
    },
    {
      warehouseName: "BODEGA REPUBLICA DOMINICANA",
      warehouseCode: "01",
      isActive: true
    },
    {
      isActive: true,
      warehouseName: "BODEGA SAN PEDRO",
      warehouseCode: "BS"
    },
    {
      isActive: true,
      warehouseName: "BODEGA TEGUCIGALPA",
      warehouseCode: "T"
    },
    {
      isActive: true,
      warehouseCode: "56",
      warehouseName: "CARGA TRANSÍSTMICA, S.A. (TC)"
    },
    {
      isActive: true,
      warehouseCode: "54",
      warehouseName: "CEVA (TC)"
    },
    {
      warehouseName: "COCOSOLITO",
      warehouseCode: "44",
      isActive: true
    },
    {
      warehouseCode: "37",
      isActive: true,
      warehouseName: "COLON CONTAINER TERMINAL"
    },
    {
      warehouseName: "COPA COURIER",
      warehouseCode: "33",
      isActive: true
    },
    {
      warehouseCode: "12",
      warehouseName: "COPADASA (TC)",
      isActive: true
    },
    {
      warehouseName: "DGA - NICARAGUA",
      isActive: true,
      warehouseCode: "91"
    },
    {
      warehouseCode: "9",
      isActive: true,
      warehouseName: "DHL AERO EXPRESO (AEROPUERTO)"
    },
    {
      warehouseName: "DHL EXPRESS",
      warehouseCode: "61",
      isActive: true
    },
    {
      warehouseCode: "7",
      isActive: true,
      warehouseName: "DHL EXPRESS (CE)"
    },
    {
      warehouseCode: "31",
      isActive: true,
      warehouseName: "DHL GLOBAL FORWARDING"
    },
    {
      warehouseCode: "8",
      isActive: true,
      warehouseName: "DHL GLOBAL FORWARDING (PS)"
    },
    {
      warehouseName: "DHL GLOBAL FORWARDING (TC)",
      warehouseCode: "3",
      isActive: true
    },
    {
      isActive: true,
      warehouseCode: "35",
      warehouseName: "ECULINE (FRANCE FIELD)"
    },
    {
      warehouseCode: "38",
      isActive: true,
      warehouseName: "ESTAFETA CORREO CARRASQUILLA"
    },
    {
      isActive: true,
      warehouseCode: "5",
      warehouseName: "FEDEX  (TC)"
    },
    {
      warehouseCode: "57",
      warehouseName: "FEDEX (COSTA DEL ESTE)",
      isActive: true
    },
    {
      warehouseName: "GCI CARGO (TC)",
      warehouseCode: "50",
      isActive: true
    },
    {
      isActive: true,
      warehouseName: "GIRAG (TC)",
      warehouseCode: "10"
    },
    {
      isActive: true,
      warehouseCode: "42",
      warehouseName: "KUEHNE NAGEL, S.A. (TC)"
    },
    {
      warehouseCode: "11",
      isActive: true,
      warehouseName: "PACT (TC)"
    },
    {
      warehouseCode: "15",
      warehouseName: "PANALPINA (TC)",
      isActive: true
    },
    {
      warehouseName: "PANAMÀ CENTRAL TERMINAL",
      warehouseCode: "17",
      isActive: true
    },
    {
      warehouseName: "PANAMA PACIFICO",
      warehouseCode: "59",
      isActive: true
    },
    {
      warehouseCode: "21",
      isActive: true,
      warehouseName: "PROMED (BODEGA HEMODIÀLISIS)"
    },
    {
      warehouseName: "PROMED (COSTA DEL ESTE)",
      warehouseCode: "2",
      isActive: true
    },
    {
      warehouseName: "PROMED (JUAN DÌAZ)",
      isActive: true,
      warehouseCode: "23"
    },
    {
      isActive: true,
      warehouseName: "PROMED NICARAGUA",
      warehouseCode: "95"
    },
    {
      isActive: true,
      warehouseName: "PUERTO ALMIRANTE",
      warehouseCode: "48"
    },
    {
      warehouseName: "PUERTO DE BALBOA",
      warehouseCode: "26",
      isActive: true
    },
    {
      isActive: true,
      warehouseName: "PUERTO DE CRISTÒBAL",
      warehouseCode: "24"
    },
    {
      warehouseName: "PUERTO DE MANZANILLO",
      warehouseCode: "25",
      isActive: true
    },
    {
      isActive: true,
      warehouseCode: "46",
      warehouseName: "TABOSA (TC)"
    },
    {
      warehouseCode: "16",
      isActive: true,
      warehouseName: "TNT (AEROPUERTO)"
    },
    {
      isActive: true,
      warehouseCode: "4",
      warehouseName: "TOCUMEN STORAGE (TC)"
    },
    {
      warehouseName: "TRAILMÓVIL (T)",
      isActive: true,
      warehouseCode: "51"
    },
    {
      warehouseCode: "6",
      isActive: true,
      warehouseName: "UPS (AEROPUERTO)"
    },
    {
      isActive: true,
      warehouseName: "ZONA LIBRE DE COLON",
      warehouseCode: "58"
    }
  ],
  showAll: true,
  brokers: [
    {
      isActive: true,
      companyCode: "01",
      agentCode: "A4",
      name: "PANAMA CUSTOMS BROKERS",
      contactName: ""
    },
    {
      companyCode: "01",
      name: "MAERSK LINE",
      agentCode: "20",
      contactName: "",
      isActive: true
    },
    {
      agentCode: "A3",
      companyCode: "01",
      contactName: "",
      isActive: true,
      name: "ALVEO REED CORREDORES"
    },
    {
      name: "KUEHNE + NAGEL",
      agentCode: "13",
      isActive: true,
      companyCode: "01",
      contactName: ""
    },
    {
      agentCode: "14",
      companyCode: "01",
      isActive: true,
      contactName: "",
      name: "LIC.CARLOS CHUEZ"
    },
    {
      contactName: "",
      companyCode: "01",
      name: "EXTRANJERO",
      isActive: true,
      agentCode: "7"
    },
    {
      contactName: "",
      companyCode: "01",
      name: "DHL GLOBAL FORWARDING",
      agentCode: "4",
      isActive: true
    },
    {
      companyCode: "01",
      name: "DHL COURIER",
      agentCode: "2",
      contactName: "",
      isActive: true
    },
    {
      isActive: true,
      companyCode: "01",
      agentCode: "3",
      name: "FEDEX (TRASACA)",
      contactName: ""
    },
    {
      isActive: true,
      companyCode: "01",
      agentCode: "5",
      contactName: "",
      name: "AGENCIAS DE ADUANA ALVARADO"
    },
    {
      isActive: true,
      contactName: "",
      name: "UPS",
      agentCode: "6",
      companyCode: "01"
    },
    {
      agentCode: "11",
      contactName: "",
      companyCode: "01",
      isActive: true,
      name: "FASHION CONSULT INTERNATIONAL"
    },
    {
      contactName: "",
      agentCode: "1",
      companyCode: "01",
      name: "MARIA DAISY DE GUTIERREZ",
      isActive: true
    },
    {
      companyCode: "01",
      agentCode: "8",
      contactName: "",
      isActive: true,
      name: "PANAMERICAN TRANSIT CORP (PTCORP)"
    },
    {
      isActive: true,
      name: "PROMED, S.A.",
      contactName: "",
      agentCode: "9",
      companyCode: "01"
    },
    {
      agentCode: "10",
      companyCode: "01",
      isActive: true,
      name: "TNT",
      contactName: ""
    },
    {
      companyCode: "01",
      isActive: true,
      name: "TABOSA, S.A.",
      agentCode: "19",
      contactName: ""
    },
    {
      agentCode: "21",
      name: "SEA CARGO LOGISTICS PANAMA, S.A.",
      companyCode: "01",
      isActive: true,
      contactName: ""
    },
    {
      companyCode: "01",
      contactName: "",
      agentCode: "15",
      name: "QUALITY FREIGHT CORP.",
      isActive: true
    },
    {
      isActive: true,
      contactName: "",
      agentCode: "16",
      companyCode: "01",
      name: "CEVA"
    },
    {
      name: "AMERICA GLOBAL LOGISTICS",
      isActive: true,
      agentCode: "18",
      contactName: "",
      companyCode: "01"
    },
    {
      companyCode: "01",
      contactName: "",
      agentCode: "12",
      isActive: true,
      name: "ENCOMIENDAS POSTALES"
    },
    {
      contactName: "",
      agentCode: "22",
      isActive: true,
      companyCode: "01",
      name: "MOLLAX PANAMA, S.A."
    },
    {
      agentCode: "A1",
      isActive: true,
      contactName: "",
      companyCode: "01",
      name: "EXPEDITORS PANAMA"
    },
    {
      agentCode: "A2",
      companyCode: "01",
      name: "ADUANA SANTOS, S.A",
      isActive: true,
      contactName: ""
    }
  ]
}; 